function TakeQuiz(){
    return (
        <div className="quiz">
            <div className="quiz-container">
                <h2>Ready to get started with&nbsp;Stitch&nbsp;Fix?</h2>
                <button>Take your style quiz</button>
            </div>
        </div>
    )
} 
export default TakeQuiz